import axios from 'axios';

const axiosCustomerInstance = axios.create({
  baseURL: process.env.REACT_APP_API_CUSTOMER_URL || '',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosCustomerInstance;
